"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getFormatedDuration;

var _moment = _interopRequireDefault(require("moment"));

var _momentDurationFormat = _interopRequireDefault(require("moment-duration-format"));

(0, _momentDurationFormat["default"])(_moment["default"]);

function getFormatedDuration(_ref) {
  var duration = _ref.duration,
      _ref$unit = _ref.unit,
      unit = _ref$unit === void 0 ? 'seconds' : _ref$unit,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? 'h:mm:ss' : _ref$format,
      _ref$unneededStart = _ref.unneededStart,
      unneededStart = _ref$unneededStart === void 0 ? '0:' : _ref$unneededStart,
      _ref$trim = _ref.trim,
      trim = _ref$trim === void 0 ? false : _ref$trim,
      _ref$usePlural = _ref.usePlural,
      usePlural = _ref$usePlural === void 0 ? true : _ref$usePlural;

  var formatedDuration = _moment["default"].duration(duration, unit).format(format, {
    trim: trim,
    usePlural: usePlural
  });

  return unneededStart && formatedDuration.startsWith(unneededStart) ? formatedDuration.substring(unneededStart.length) : formatedDuration;
}
//# sourceMappingURL=getFormattedDuration.js.map